<template>
  <div class="usrprdtext topmargin btm-2">
    <h4 class="font-bold-24">Assigned Products</h4>
    <div class="mb-4">
      <el-button
        plain
        class="delbtn"
        @click="showAddProducts"
        id="assignproduct"
      >
        <img
          src="@/assets/icons/add.svg"
          style="width: 40px"
          alt="Assign products"
          title="Click to assign products"
        />
      </el-button>
      <el-button
        plain
        class="delbtn"
        @click="assignAddon"
        id="addignaddon"
        :disabled="!enablebuttons"
      >
        <img
          src="@/assets/icons/addaddonenabled.svg"
          style="width: 40px"
          v-if="enablebuttons"
          alt="Add add-on"
          title="Click to add add-ons"
        />
        <img
          src="@/assets/icons/addaddondisabled.svg"
          style="width: 40px"
          v-if="!enablebuttons"
          alt="Add add-on disabled"
          title="Click to add add-ons"
        />
      </el-button>
      <el-button
        plain
        class="delbtn"
        @click="removeAddon"
        id="removeaddon"
        :disabled="!enablebuttons && DisableDeleteAddon"
      >
        <img
          src="@/assets/icons/deladdonenabled.svg"
          style="width: 40px"
          v-if="enablebuttons && !DisableDeleteAddon"
          alt="Delete add-on"
          title="Click to delete add-ons"
        />
        <img
          src="@/assets/icons/deladdondisabled.svg"
          style="width: 40px"
          v-if="DisableDeleteAddon"
          alt="Delete add-on disabled"
          title="Click to delete add-ons"
        />
      </el-button>
      <el-button
        plain
        class="delbtn"
        @click="removeEntitlements"
        id="removeentitlement"
        :disabled="!enablebuttons"
      >
        <img
          src="@/assets/icons/delete.svg"
          style="width: 40px"
          v-if="enablebuttons"
          alt="Delete assigned products"
          title="Click to remove assigned products"
        />
        <img
          src="@/assets/icons/deletedisabled.svg"
          style="width: 40px"
          v-if="!enablebuttons"
          alt="Delete assigned products disabled"
          title="Click to remove assigned products"
        />
      </el-button>
    </div>
  </div>
  <AssignedProducts />
  <el-drawer
    v-model="showAddprod"
    direction="rtl"
    size="40%"
    destroy-on-close
    :before-close="closeModal"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :wrapperClosable="false"
  >
    <AssignProductsModal />
  </el-drawer>
  <el-drawer
    v-model="showAssignAddon"
    direction="rtl"
    size="40%"
    destroy-on-close
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :wrapperClosable="false"
  >
    <AssignAddonModal />
  </el-drawer>
  <el-drawer
    v-model="showRemoveAddon"
    direction="rtl"
    size="40%"
    destroy-on-close
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="closeModal"
  >
    <RemoveAddonsModal />
  </el-drawer>
  <el-drawer
    v-model="showRemoveEntitlements"
    direction="rtl"
    size="40%"
    destroy-on-close
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :wrapperClosable="false"
  >
    <RemoveEntitlementsModal />
  </el-drawer>
</template>

<style lang="scss">
.usrprdtext {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.optbtn {
  color: #101010;
  background: unset;
  border: unset;
  width: 50px;
  height: 50px;
  margin-right: 10px;
  padding: unset;
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
import AssignedProducts from "@/components/AssignedProducts.vue";
import AssignProductsModal from "@/components/AssignProductsModal.vue";
import AssignAddonModal from "@/components/AssignAddonModal.vue";
import RemoveAddonsModal from "@/components/RemoveAddonsModal.vue";
import RemoveEntitlementsModal from "./RemoveEntitlementsModal.vue";
import { FlowActionTypes } from "@/store/flowstore/FlowActionTypes";
import { UserActionTypes } from "@/store/userstore/UserActionTypes";
import { ProductActionTypes } from "@/store/productstore/ProductActionTypes";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "UserDetails",
  components: {
    AssignedProducts,
    AssignProductsModal,
    RemoveAddonsModal,
    AssignAddonModal,
    RemoveEntitlementsModal,
  },
  computed: {
    ...mapGetters([
      "getShowAddProducts",
      "getSelectedProducts",
      "getUserData",
      "getShowAssignAddon",
      "getAddonProducts",
      "getShowRemoveAddon",
      "getShowRemoveEntitlement",
    ]),
    showAddprod: {
      get(): any {
        return this.getShowAddProducts;
      },
      set() {
        this.$store.dispatch(FlowActionTypes.SET_SHOW_ADDPRODUCTS, false);
      },
    },
    showAssignAddon: {
      get(): boolean {
        return this.getShowAssignAddon;
      },
      set() {
        this.$store.dispatch(FlowActionTypes.SET_SHOW_ASSIGNADDON, false);
      },
    },
    showRemoveAddon: {
      get(): boolean {
        return this.getShowRemoveAddon;
      },
      set() {
        this.$store.dispatch(FlowActionTypes.SET_SHOW_REMOVEADDON, false);
      },
    },
    showRemoveEntitlements: {
      get(): boolean {
        return this.getShowRemoveEntitlement;
      },
      set() {
        this.$store.dispatch(FlowActionTypes.SET_SHOW_REMOVEENTITLEMENT, false);
      },
    },
    DisableDeleteAddon(): boolean {
      return this.getAddonProducts.length === 0;
    },
    enablebuttons(): boolean {
      return this.getSelectedProducts.length !== 0;
    },
  },
  data() {
    return {};
  },
  methods: {
    showAddProducts() {
      this.$store.dispatch(FlowActionTypes.SET_TASK_TYPE, "prodAss");
      this.$store.dispatch(FlowActionTypes.SET_SHOW_ADDPRODUCTS, true);
      this.$store.dispatch(FlowActionTypes.SET_SELECTED_USERS, [
        this.getUserData,
      ]);
    },

    removeEntitlements() {
      this.$store.dispatch(FlowActionTypes.SET_SHOW_REMOVEENTITLEMENT, true);
    },
    assignAddon() {
      this.$store.dispatch(FlowActionTypes.SET_TASK_TYPE, "assignaddon");
      this.$store.dispatch(FlowActionTypes.SET_SHOW_ASSIGNADDON, true);
    },
    removeAddon() {
      this.$store.dispatch(FlowActionTypes.SET_SHOW_REMOVEADDON, true);
    },
    closeModal() {
      this.$store.dispatch(FlowActionTypes.SET_SHOW_ADDPRODUCTS, false);
      this.$store.dispatch(FlowActionTypes.SET_SHOW_ADDUSER, false);
      this.$store.dispatch(FlowActionTypes.SET_SELECTED_USERS, []);
      this.$store.dispatch(FlowActionTypes.SET_PRODUCT_DATA, {});
      this.$store.dispatch(FlowActionTypes.SET_TASK_TYPE, "none");
      this.$store.dispatch(ProductActionTypes.SET_AVAILABLE_PRODUCTS, {
        items: [],
      });
      this.$store.dispatch(
        UserActionTypes.SET_UNASSIGNED_SUBSCRIPTIONUSERS,
        {}
      );
    },
  },
});
</script>
